import * as actionTypes from "../../actions/actionTypes";

const INITIAL_STATE = {
  nonAuctionQuotes: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: null,
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
};

const nonAuctionReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_NON_AUCTION_QUOTES_LOADING:
      return {
        ...state,
        nonAuctionQuotes: {
          ...state.nonAuctionQuotes,
          get: {
            ...state.nonAuctionQuotes.get,
            loading: true,
            reset: false,
            success: {
              ...state.nonAuctionQuotes.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_NON_AUCTION_QUOTES_SUCCESS:
      return {
        ...state,
        nonAuctionQuotes: {
          ...state.nonAuctionQuotes,
          get: {
            ...state.nonAuctionQuotes.get,
            loading: false,
            reset: false,
            success: {
              ...state.nonAuctionQuotes.get.success,
              ok: true,
              data: action.payload?.non_auction_quote_details,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actionTypes.GET_NON_AUCTION_QUOTES_FAILURE:
      return {
        ...state,
        nonAuctionQuotes: {
          ...state.nonAuctionQuotes,
          get: {
            ...state.nonAuctionQuotes.get,
            loading: false,
            reset: false,
            success: {
              ...state.nonAuctionQuotes.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              accessDenied: action.payload.accessDenied,
            },
          },
        },
      };
    case actionTypes.GET_NON_AUCTION_QUOTES_RESET:
      return {
        ...state,
        nonAuctionQuotes: {
          ...state.nonAuctionQuotes.get,
          get: {
            ...INITIAL_STATE.nonAuctionQuotes.get,
            reset: true,
          },
        },
      };
  }
  return state;
};

export default nonAuctionReducers;
